import styled from "styled-components";
import { ContentFormatter } from "discover.medical.react-component-library";
import { SeparateLineUfoDiv } from "../ContentBlock/preProcessors/_styled";

export const StyledContentSection = styled.section`
  @media print {
    margin-top: -${({ theme }) => theme.space.md};
  }

  .modalDialog.DMX_div {
    @media print {
      display: none;
    }
  }

  .modalDialog.DMX_div h3 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .modal-dialog {
    position: relative;
    width: auto;
    margin: 135px auto 350px;
  }

  .mapping-link {
    margin-bottom: ${({ theme }) => theme.space.sm};
  }

  //Start legacy references modal styling

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    .modal-dialog {
      width: 500px;
    }
  }

  .modal-content .DMX_div .DMX_ul {
    margin: 0 0 0 32px;
    padding: 0;
    list-style: none outside none;
  }

  .modal-content {
    position: relative;
    background-color: #fff;
    border: 1px solid #999;
    border-radius: 6px;
    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    background-clip: padding-box;
    outline: none;
  }

  .modal-header {
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
    min-height: 16.4286px;
  }

  .close,
  .cross {
    font-size: 19.5px;
    font-weight: bold;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
  }

  .close {
    filter: alpha(opacity=20);
    margin-top: -2px;
    position: absolute;
    right: 5px;
    text-align: center;
    top: 2px;
    width: 21px;
    text-decoration: none;
    -moz-border-radius: 12px;
    border-radius: 12px;
    float: right;
    opacity: 0.2;
  }

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .DMX_button.close,
  .DMX_button.cross {
    padding: 0;
    cursor: pointer;
  }

  .DMX_button.close {
    background: transparent;
    border: 0;
    -webkit-appearance: none;
  }

  .DMX_button.cross {
    background: none repeat scroll 0% 0% transparent;
    border: 0 none;
    float: right;
    text-align: right;
    clear: left;
    padding-top: 14px;
    padding-right: 10px;
    width: 30px;
  }

  .modal-title {
    margin: 0;
  }

  .modal-data {
    padding: 20px;
    max-height: 250px;
    overflow: auto;
    font-size: 1rem;
    line-height: 1.5;
  }

  .modal-data.DMX_div > br {
    display: none;
  }

  .modal-footer {
    display: none;
    padding: 3px 20px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
  }

  .modal-data > br {
    display: none;
    height: 0;
  }

  .modal-data > .DMX_a {
    display: block;
  }

  .modal-data > .DMX_a:first-of-type {
    margin-top: 0.5rem;
  }

  .modalDialog {
    position: fixed;
    font: 13px Arial, sans-serif;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    opacity: 0;
    pointer-events: none;
  }

  .modalDialog:target {
    opacity: 1;
    visibility: visible !important;
    pointer-events: auto;
  }

  .modalid {
    color: #1675be;
    text-decoration: none;
    padding: 1px !important;
    list-style: none outside none;
    font-size: 0.75rem;
    display: inline-block !important;
    vertical-align: super;
  }
  .modalid+.modalid {
    margin-left: 0.5rem;
  }

  .modalid .DMX_a:hover {
    text-decoration: none;
  }

  //End legacy references modal styling
`;

export const ContentBlockItemWrapper = styled.div`
  .DMX_a[id]:not([href]):empty {
    display: block;
    position: relative;
    top: -6.75rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      top: -5rem;
    }
  }

  ol li {
    &::before {
      content: "";
    }
    ${({ theme }) => `
    &::marker {
      font-size: ${theme.font.size.sm};
    }
    @media (min-width: ${theme.breakpoints.sm}) {
      &::marker {
        font-size: ${theme.font.size.md};
      }
    }
  `}
  }

  ol li {
    list-style-type: decimal;
  }

  .evidence-reference {
    display: block;
    font-size: ${({ theme }) => theme.font.size.sm};
  }

  @media print {
    display: ${({ printHide }) => printHide && "none"};
  }
`;

const linkIconStyles = ({ theme }) => `
  a svg {
    height: 1.1rem;
    width: 1.1rem;
    margin: ${theme.space.xs};
    margin-bottom: -${theme.space.xs};
  };
  sup a svg { display: none };
`;
export const StyledContentBlock = styled(ContentFormatter)`
  ${linkIconStyles}
`;

export const ListStyledContentBlock = styled(ContentFormatter)`
  .evidenceSummary ${SeparateLineUfoDiv} {
    margin: 1.25rem 0 -0.75rem -1.125rem;
    position: relative;
  }

  ${linkIconStyles}

  ol li::before {
    content: "";
  }

  ol li {
    list-style-type: decimal;
  }

  @media print {
    display: ${({ printHide }) => printHide && "none"};
  }
`;

export const Container = styled.div`
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.sm};
    @media print {
      padding-top: 0;
    }
  }
  ${({ $isEmphasized, theme }) =>
    $isEmphasized &&
    `
    background-color: ${theme.colors.gray100};
    padding: ${theme.space.xs} ${theme.space.md};
    border: 1px solid ${theme.colors.gray400};
    margin-top: ${theme.space.sm};
  `}
`;

export const HiddenContainer = styled.div`
  display: none;
  @media print {
    display: block;
  }
`;

export const PrintSubSectionsWrapper = styled.div`
  @media print {
    display: ${({ printHide }) => printHide && "none"};
  }
`;

export const SubSectionsWrapper = styled.div`
  ${({ parentSelectedForPrint, isNumberedList }) =>
    !parentSelectedForPrint &&
    isNumberedList &&
    `
    @media print {
      display: none;
    }
  `}

  ${({ isNumberedList, theme }) =>
    isNumberedList &&
    `
  margin-left: 1.25rem;

  h3, p,
  .RCL_ContentBlock p:not(:last-child) {
    margin: 0;
    padding: 0
  }

  h5 {
    margin: 0 0 0.5rem;
  }

  & > div {
    display: list-item;
    list-style-type: decimal;
    margin-bottom: 1rem;

    &::marker {
      font-size: ${theme.font.size.sm};
    }

    @media (min-width: ${theme.breakpoints.sm}) {
      &::marker {
        font-size: ${theme.font.size.md};
      }
    }
  }

  a {
    color: ${theme.colors.anchor};
  }
`}
`;
